import { jsx as _jsx } from "react/jsx-runtime";
import { EndUserReplaced } from './endUserReplaced';
import { AutoreplySent, ConversationAssigned, ConversationClaimed, ConversationClosed, ConversationCreated, ConversationFollowup, ConversationLanguageUpdated, ConversationOffered, ConversationOfferResponse, ConversationOfferTimeout, ConversationPending, ConversationRated, ConversationReopened, ConversationTagged, ConversationTransferred, ConversationUnassigned, MessageAdded, NoteAdded, RatingCancelled, RatingOffered, RatingScheduled, RoutedThroughFlow, } from './';
/**
 * Represents a component that based on the log entry type renders a component
 * for that type.
 */
export function ComponentByLogType({ entry, messages, }) {
    switch (entry.activity_type) {
        case 'CONVERSATION_CREATED_BY_CUSTOMER':
        case 'CONVERSATION_CREATED_BY_AGENT':
            return _jsx(ConversationCreated, { entry: entry });
        case 'CONVERSATION_CLOSED':
            return _jsx(ConversationClosed, { entry: entry });
        case 'CONVERSATION_REOPENED':
            return _jsx(ConversationReopened, { entry: entry });
        case 'CONVERSATION_PENDING':
            return _jsx(ConversationPending, { entry: entry });
        case 'TAG_ADDED':
        case 'TAG_REMOVED':
            return _jsx(ConversationTagged, { entry: entry });
        case 'CONVERSATION_OFFERED':
            return _jsx(ConversationOffered, { entry: entry });
        case 'NOTE_ADDED':
            return _jsx(NoteAdded, { entry: entry });
        case 'CONVERSATION_ASSIGNED':
            return _jsx(ConversationAssigned, { entry: entry });
        case 'TRANSFER_INITIATED':
        case 'TRANSFER_FAILED':
        case 'TRANSFER_SUCCESSFUL':
            return _jsx(ConversationTransferred, { entry: entry });
        case 'MESSAGE_ADDED_BY_AGENT':
        case 'MESSAGE_ADDED_BY_CUSTOMER':
            return (_jsx(MessageAdded, { entry: entry, messages: messages }));
        case 'CONVERSATION_OFFER_ACCEPTED':
        case 'CONVERSATION_OFFER_REJECTED':
            return _jsx(ConversationOfferResponse, { entry: entry });
        case 'CONVERSATION_OFFER_TIMEOUT':
            return _jsx(ConversationOfferTimeout, { entry: entry });
        case 'CONVERSATION_LANGUAGE_UPDATED':
            return (_jsx(ConversationLanguageUpdated, { entry: entry }));
        case 'CONVERSATION_RATING_SCHEDULED':
        case 'CONVERSATION_RATING_UNSCHEDULED':
            return _jsx(RatingScheduled, { entry: entry });
        case 'CONVERSATION_RATING_OFFERED':
            return _jsx(RatingOffered, { entry: entry });
        case 'CONVERSATION_RATED':
            return _jsx(ConversationRated, { entry: entry });
        case 'CONVERSATION_RATING_CANCELLED':
            return _jsx(RatingCancelled, { entry: entry });
        case 'FOLLOWUP_ADDED':
        case 'FOLLOWUP_EXPIRED':
        case 'FOLLOWUP_REMOVED':
            return _jsx(ConversationFollowup, { entry: entry });
        case 'CONVERSATION_CLAIMED':
            return _jsx(ConversationClaimed, { entry: entry });
        case 'CONVERSATION_AUTOREPLY_SENT':
            return _jsx(AutoreplySent, { entry: entry });
        case 'CONVERSATION_UNASSIGNED':
            return (_jsx(ConversationUnassigned, { entry: entry }));
        case 'CONVERSATION_ROUTED_THROUGH_FLOW':
            return _jsx(RoutedThroughFlow, { entry: entry });
        case 'CONVERSATION_END_USER_REPLACED':
            return _jsx(EndUserReplaced, { entry: entry });
        default:
            console.warn(`Activity Log entry of type ${entry.activity_type} is not supported.`);
            return null;
    }
}
